import { SessionSummary } from '@bioliberty/lifemind';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import posthog from 'posthog-js';
import { useUpdateSessionNoteMutation } from '../../../api';
import { Event } from '../../../lib/posthog';
import { cn } from '../../../util';

export interface SessionNoteRatingProps {
  session: SessionSummary;
}

export function SessionNoteRating({ session }: SessionNoteRatingProps) {
  const [updateSessionNote, { isLoading: isUpdating }] = useUpdateSessionNoteMutation();

  const onThumbsUp = async () => {
    if (isUpdating) {
      return;
    }

    const helpful = session.noteHelpful === true ? null : true;
    await updateSessionNote({ sessionId: session.sessionId, helpful });
    posthog.capture(Event.SessionNoteRatingButtonClick, { helpful });
  };

  const onThumbsDown = async () => {
    if (isUpdating) {
      return;
    }

    const helpful = session.noteHelpful === false ? null : false;
    await updateSessionNote({ sessionId: session.sessionId, helpful });
    posthog.capture(Event.SessionNoteRatingButtonClick, { helpful });
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm">Helpful?</span>
      <ThumbsUp
        className={cn('hover:text-accent w-4 cursor-pointer', session.noteHelpful && 'text-accent')}
        onClick={onThumbsUp}
      />
      <ThumbsDown
        className={cn('hover:text-accent w-4 cursor-pointer', session.noteHelpful === false && 'text-accent')}
        onClick={onThumbsDown}
      />
    </div>
  );
}
